export const onDomChange = (element, cb) => {
    try {
        const observer = new MutationObserver(mutations => {
            cb(observer, mutations);
        });
        const config = { childList: true, subtree: true };
        observer.observe(element, config);
        return true;
    } catch (error) {
        return false;
    }
};
